import Banner from "components/common/Banner";
import OverlayMobile from "./OverlayMobile";
import Overlay from "./Overlay";

import envs from "config/envs";

const BannerComplianceAndGovernance = () => {
  const renderBanner = ({ background, height, isMobile = false, children }) => (
    <Banner
      width="100vw"
      height={height}
      background={isMobile ? undefined : background}
      mobileBackground={isMobile ? background : undefined}
      isMobile={isMobile}
      alt={
        isMobile
          ? undefined
          : "Três profissionais em trajes formais reunidos em uma mesa de escritório, analisando documentos e discutindo estratégias. Dois homens e uma mulher estão focados, com expressões atentas e materiais de trabalho, como anotações, xícaras de café e laptop sobre a mesa"
      }
    >
      <Banner.Overlay center={false} isMobile={isMobile}>
        {children}
      </Banner.Overlay>
    </Banner>
  );

  return (
    <section role="banner">
      {renderBanner({
        background: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner-conformidade-e-governanca.webp`,
        height: "45vw",
        children: <Overlay />,
      })}
      {renderBanner({
        background: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner-conformidade-e-governanca_mobile.webp`,
        height: "130vw",
        isMobile: true,
        children: <OverlayMobile />,
      })}
    </section>
  );
};

export default BannerComplianceAndGovernance;
